var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.location
        ? [
            _c(
              "google-map",
              {
                ref: "Map",
                attrs: { id: "map", zoom: 12, center: _vm.location }
              },
              [
                _c("google-map-marker", {
                  attrs: {
                    position: _vm.location,
                    icon:
                      "/assets/web/images/marker_" + _vm.base_category + ".png"
                  }
                })
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }